import React from "react";
import Card from "../../../../common/Card/Card";
import styles from "./PaymentStatus.module.scss";
import Lottie from "lottie-react";
import success from "../../../../../assets/animations/success.json";
import failed from "../../../../../assets/animations/failed.json";
import loading from "../../../../../assets/animations/loading.json";
import Button from "../../../../common/Button/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../../../../routes";

const PaymentStatus = () => {
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("redirect_status");

  const redirectToMarketPlace = () => {
    history(ROUTES.WALLETPORTFOLIO);
  };

  return (
    <>
      <Card title="Payment Status" className={styles.payment}>
        {paymentStatus === "succeeded" ? (
          <div className={`${styles.box} ${styles.success}`}>
            <Lottie animationData={success} loop={false} />
            <h2>Payment Success</h2>
            <Button onClick={redirectToMarketPlace}>
              Go To Wallet Portfolio
            </Button>
          </div>
        ) : (
          <div className={`${styles.box} ${styles.failed}`}>
            <Lottie animationData={failed} loop={false} />
            <h2>Payment Failed</h2>
            <Button onClick={redirectToMarketPlace}>
              Go To Wallet Portfolio
            </Button>
          </div>
        )}

        {/* <div className={`${styles.box} ${styles.loading}`}>
					<Lottie
						animationData={loading}
						loop={true}
					/>
					<h6>Loading...</h6>
				</div> */}
      </Card>
    </>
  );
};
export default PaymentStatus;
